import moment from 'moment';
import { AppointmentHistory } from '../../../types/history';
import AcademiaSectionWrapper from '../AcademiaSectionWrapper';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const AppointmentHistoryDetailsModal = ({
  handleModalClose,
  isAssociate,
  appointment,
}: {
  handleModalClose: () => void;
  isAssociate: boolean;
  appointment: AppointmentHistory;
}) => {
  // destructuring the appointment object here
  const {
    client_full_name,
    associate_full_name,
    date,
    start_time,
    end_time,
    created_at,
    additional_info,
  } = appointment || {};

  // rendering appointment history details modal component here
  return (
    <ParentModal onClick={handleModalClose} customWidthClass='md:w-[700px]'>
      <ModalTitle titleText='appointment details' />

      <section>
        <AcademiaSectionWrapper sectionTitle='Appointment Details'>
          {isAssociate ? (
            <div className='flex items-center gap-2 text-lg text-base-light-blue'>
              <p>Client Name:</p>
              <p className='font-medium'>{client_full_name}</p>
            </div>
          ) : (
            <div className='flex items-center gap-2 text-lg text-base-light-blue'>
              <p>Associate Name:</p>
              <p className='font-medium'>{associate_full_name}</p>
            </div>
          )}

          <div className='grid grid-cols-[130px_5px_1fr] gap-1 text-sm text-base-dark-green mt-2'>
            <p>Appointment Date</p>
            <p>:</p>
            <p className='font-medium'>{date}</p>
          </div>
          <div className='grid grid-cols-[130px_5px_1fr] gap-1 text-sm text-base-dark-green'>
            <p>Appointment Slot</p>
            <p>:</p>
            <p className='font-medium'>{`${start_time} - ${end_time}`}</p>
          </div>
          <div className='flex items-center gap-2 text-sm text-base-purple mt-2'>
            <p>Booked On:</p>
            <p className='font-medium'>
              {moment(created_at).format('DD-MM-YYYY')}
            </p>
          </div>
        </AcademiaSectionWrapper>

        <AcademiaSectionWrapper sectionTitle='Additional Info'>
          <p className='text-base-dark-blue'>{additional_info || 'N/A'}</p>
        </AcademiaSectionWrapper>
      </section>
    </ParentModal>
  );
};

export default AppointmentHistoryDetailsModal;
